module.exports = __webpack_public_path__ + "img/02.fdda8e5d.jpg";